import { IApplicationState } from '../../types/redux';

export function selectCrossLinks({ seoCrossLinks }: IApplicationState) {
  return seoCrossLinks;
}
